import {
  Component, Input, OnInit, OnDestroy,
  Output, EventEmitter, NgZone,
} from '@angular/core';
import { Observable } from 'rxjs';
import {takeWhile} from 'rxjs/operators';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';


@Component({
  moduleId: module.id,
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
})
export class AppHeaderComponent implements OnInit, OnDestroy {

  scrolled: boolean = false;

  @Input() topBgColor: string = 'darkred';
  @Input() bottomBgColor: string = 'white';
  @Input() ghostValue: string = 'app-header';

  protected isActive: boolean = true;

  constructor(
    protected ngZone: NgZone,
  ) {}

  ngOnInit() {
    this.subscribeWindowScroll();
  }

  ngOnDestroy() {
    this.isActive = false;
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private subscribeWindowScroll(): void {
   this.ngZone.runOutsideAngular(() => {
     fromEvent(window, 'scroll')
     .pipe(takeWhile(() => this.isActive))
     .subscribe((e: any) => {
       this.scrolled = window.pageYOffset > 10;
     });
   });
  }
}
